<template>
  <Modal
    :open="displayModal"
    title="Modify Stringer Percent"
    size="small"
    :showEscapeButton="true"
    :showAcceptButton="true"
    :showDangerButton="false"
    acceptButtonText="Update Percent"
    @close="displayModal = false"
    @onSuccess="savePercent"
    ref="modal"
  >
    <dl class="grid grid-cols-1 gap-4" v-if="data !== null">
      <div class="col-span-1">
        <div class="flex flex-row justify-between">
          <label
            for="stringer_percent"
            class="block text-sm font-medium text-gray-600"
            >Stringer Percent
          </label>
        </div>

        <div class="mt-1 relative rounded-md shadow-sm">
          <input
            type="number"
            name="stringer_percent"
            id="stringer_percent"
            class="focus:ring-blue-500 focus:border-blue-500 block w-full pl-4 pr-4 sm:text-sm border-gray-300 rounded-md shadow-sm "
            placeholder="0"
            aria-describedby="price-currency"
            v-model="percent"
          />
          <div
            class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
          >
            <span class="text-gray-500 sm:text-sm" id="price-currency">
              %
            </span>
          </div>
        </div>
      </div>
      <div class="col-span-1">
        <div class="flex flex-row justify-between">
          <label
            for="stringer_percent"
            class="block text-sm font-medium text-gray-600"
            >Social Percent
          </label>
        </div>

        <div class="mt-1 relative rounded-md shadow-sm">
          <input
            type="number"
            name="stringer_percent"
            id="stringer_percent"
            class="focus:ring-blue-500 focus:border-blue-500 block w-full pl-4 pr-4 sm:text-sm border-gray-300 rounded-md shadow-sm "
            placeholder="0"
            aria-describedby="price-currency"
            v-model="social_percent"
          />
          <div
            class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
          >
            <span class="text-gray-500 sm:text-sm" id="price-currency">
              %
            </span>
          </div>
        </div>
      </div>
    </dl>
  </Modal>
</template>

<script>
import * as Config from "@/config";
import { mapActions } from "vuex";

import Modal from "@/components/Modal";

export default {
  data() {
    return {
      stringerPercentModal: false,
      displayModal: false,
      data: {},
      percent: 0,
      social_percent: 0,
    };
  },

  components: {
    Modal
  },

  mounted() {
    this.$nextTick(
      function() {
        this.$eventBus.$on(
          "admin-modify-stringer-percent-open-modal",
          this.open
        );
      }.bind(this)
    );
  },

  destroyed() {
    this.$eventBus.$off("admin-modify-stringer-percent-open-modal", this.open);
  },

  methods: {
    ...mapActions(["addToastMessage"]),
    open(data) {
      console.log(data);
      this.displayModal = true;
      this.data = data;

      if (this.data.settings.percent !== null) {
        this.percent = this.data.settings.percent;
      }

      if (this.data.settings !== null && this.data.settings.social_percent !== null) {
        this.social_percent = this.data.settings.social_percent;
      } else {
        this.social_percent = 50
      }
    },
    async savePercent() {
      var data = {
        percent: this.percent,
        social_percent: this.social_percent
      };

      try {
        const res = await this.$http.post(
          Config.apiPath + "/api/v2/admin/users/" + this.data.id + "/settings",
          data
        );
        this.$eventBus.$emit(
          "admin-modify-stringer-percent-return",
          this.percent
        );
        this.addToastMessage({
          title: "Success",
          text:
            this.data.name +
            "'s percentage was successfully updated.",
          type: "success"
        });
        this.displayModal = false;
      } catch (e) {
        alert("Error encountered");
        console.log(e);
      }
    }
  }
};
</script>
